<template>
    <Layout>
        <Sider class="siderclass" collapsible v-model="isCollapsed" :collapsed-width="30" :hide-trigger="true" ref="cloudSider" @on-collapse="changestate" :style="{background:treeDisp?'#fff':'#515a6e',borderRight:'1px solid #e8eaec'}">
            <Button type="text" @click="toggle" icon="ios-menu" :style="{width:'100%',borderRadius:'0px',boxShadow:'none',color:'white',background:'#2db7f5',display:leftTreeToggleMenuBtn?'block':'none'}" size="small"></Button>
            <!-- <Menu :theme="theme3" :active-name="activeName" width="auto" height="80vh" @on-select="menulinkto" :style="{width:'100%',display:treeDisp?'block':'none'}" ref="mymenubar">
        <MenuGroup title="智慧云端">
          <MenuItem name="1">
          <Icon type="ios-folder" />
          上传文件库
          </MenuItem> -->
            <!--     <MenuItem name="2">
          <Icon type="ios-create" />
          我的工作薄
          </MenuItem> -->
            <!-- </MenuGroup>
      </Menu> -->
            <div style="position: relative;">
                <div :style="{textAlign:'center',display:treeDisp?'block':'none'}">
                    <br />
                    <Button type="default" style="display: inline-block;width: 80%" @click="reloadSearch">分类重置</Button>
                </div>
                <div class="maskLayer">
                    <FullTree ref="myFullTree" @OnSelectChange="showmap" @OnLocalSelectChange="showmap" @refreshMap="flashMap" :style="{width:'100%',display:treeDisp?'block':'none'}" :key="rid"></FullTree>
                    <!-- 特定情况下的遮罩树 -->
                    <Spin fix v-if="isShowMask" style="width: 180px;height:500px;">
                        <div></div>
                    </Spin>
                </div>
            </div>
        </Sider>
        <!--    <Layout  style="height:78.8vh"> -->
        <!--  layout会根据是否分屏来调整容器的高度,用以适应affix的固定 -->
        <!--  <Layout  :style="{height:sliderLength>0?'78.8vh':'auto'}"> -->
        <Layout class="layoutstyle">
            <Content class="contentclass">
                <!-- <MyRoadMap ref="myroad" style="padding-left: 10px;display: none;"></MyRoadMap> -->
                <div style="background:#FFFFFF;padding-left: 5px;">
                    <MyRoadMap ref="myroad" style="margin: 0px 0px;"></MyRoadMap>
                </div>
                <Card :bordered="false" class="cardstyle">
                    <!--  <div style="height: auto;"> -->
                    <div>
                        <router-view v-if="isRouterAlive" @clear-tree-select="clearTreeId"></router-view>
                    </div>
                </Card>
            </Content>
        </Layout>
        <!--   <Modal v-model="modalSaveNotice" width="450" :mask-closable="false" :z-index="1501">
      <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
        <Icon type="ios-information-circle"></Icon>
        <span>您有文档未保存</span>
      </p>
      <div style="text-align:center">
        确认不保存文档并离开么?
      </div>
      <div slot="footer">
        <Button type="text" size="large" @click="mCancel">不保存</Button>
        <Button type="primary" size="large" @click="mSave">返回保存</Button>
      </div>
    </Modal> -->
    </Layout>
</template>
<script>
import Vue from 'vue'
import RoadMap from './../road_map.vue'
import store from '../../store'
import AsideMenuCache from '../../components/aside_menu_cache.vue'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import eventBus from "../../components/common/event_bus.js"
export default {
    name: 'SmartCloud',
    data() {
        return {
            isShowMask: true,
            rid: +new Date(),
            theme3: 'primary',
            isRouterAlive: false,
            pageType: "",
            activeName: "1",
            isCollapsed: false,
            leftTreeToggleMenuBtn: true,
            treeDisp: true,
            modalSaveNotice: false,
            multiScreen: false,
            classid: '',
        }
    },
    provide() {
        return {
            reload: this.reload,
            getclassid: this.getCloudClassId,
            activeselector:this.activeTreeSelector,
        }
    },
    components: {
        'MyRoadMap': RoadMap,
        'FullTree': AsideMenuCache,
    },
    methods: {
        activeTreeSelector(){
            this.isShowMask=false
        },
        getCloudClassId() {
            return this.classid
        },
        clearTreeId(){
            console.log('clearTreeId====>')
            this.classid = ''
             eventBus.$emit("user-refresh-newlist")
        },
        reloadSearch() {
            //更换key以重置组件
            this.rid = +new Date()
            this.classid = ''
            //重置分类时，触发列表更新
            eventBus.$emit("cloud-tree-select", '')
            //this.$refs.searchlist.treeSelect()
        },
        flashMap(maps) {
            this.$refs.myroad.listen(maps);
        },
        showmap(maps, tabValue, cityValue) {
            console.log(maps, tabValue)
            var id = "";
            var selectNode = null
            var len
            if (maps !== undefined && maps.length > 0) {
                len = maps.length
            }
            if (maps[len - 1].node !== null) {
                selectNode = maps[len - 1].node
                id = selectNode.value
            }
            console.log("showmap id:" + id)
            this.$refs.myroad.listen(maps);
            this.classid = id
            eventBus.$emit("cloud-tree-select", id)
            //this.reload()
            //this.$refs.searchlist.treeSelect(id)
        },
        // showmap(t) {

        //     //console.log("showmap:"+t)
        //     //console.log(maps);
        //     let maps = [];
        //     let mycloud = [{
        //             key: "智慧云端",
        //             value: "智慧云端",
        //             type: "cloud"
        //         },
        //         {
        //             key: "上传文件库",
        //             value: "上传文件库",
        //             type: "mycloud"
        //         },
        //     ];
        //     let mydoc = [{
        //             key: "智慧云端",
        //             value: "智慧云端",
        //             type: "cloud"
        //         },
        //         {
        //             key: "我的工作薄",
        //             value: "我的工作薄",
        //             type: "mydoc"
        //         },
        //     ];
        //     if (t === "1") {
        //         this.$refs.myroad.listen(mycloud);
        //         maps = mycloud
        //     } else if (t === "2") {
        //         this.$refs.myroad.listen(mydoc);
        //         maps = mydoc
        //     }
        //     //console.log(maps[maps.length - 1].type)
        //     this.$router.push({
        //         name: 'mycloud',
        //         query: {
        //             q_type: maps[maps.length - 1].type,
        //         }
        //     })
        //     this.reload()
        // },
        // menulinkto(t) {
        //     // console.log(this.activeName,t)
        //     //重复点击连接跳转到当前菜单将return

        //     // if(store.state.user.userId===undefined || store.state.user.userId===""){

        //     // }

        //     if (this.activeName === t) { return }
        //     if (t === "1") {
        //         if (store.state.user.workbook.isContentChanged) {
        //             //console.log(this.$Modal)
        //             this.$Modal.confirm({
        //                 title: '您的工作簿有内容未保存',
        //                 content: '<p>确定要离开并放弃保存么？</p>',
        //                 cancelText: "返回保存",
        //                 onOk: () => {
        //                     this.setContentStatefalse()
        //                     this.showmap(t)
        //                     this.activeName = t
        //                 },
        //                 onCancel: () => {
        //                     //this.activeName="2"
        //                     this.$refs.mymenubar.currentActiveName = "2"
        //                     return
        //                 }
        //             });
        //         } else {
        //             this.showmap(t)
        //             this.activeName = t

        //         }
        //     } else {
        //         this.showmap(t)
        //         this.activeName = t
        //     }

        // },

        reload() {
            this.isRouterAlive = false
            //在修改数据之后使用 $nextTick，则可以在回调中获取更新后的 DOM
            this.$nextTick(() => {
                this.isRouterAlive = true
            })
        },
        // switch () {
        //     //console.log("switch")
        //     if (this.pageType == "mycloud") {
        //         this.showmap("1")
        //         this.activeName = "1"
        //     } else if (this.pageType == "mydoc") {
        //         this.showmap("2")
        //         this.activeName = "2"
        //     } else {
        //         this.showmap("1")
        //         this.activeName = "1"
        //     }
        // },
        toggle() {
            this.$refs.cloudSider.toggleCollapse()
        },
        changestate(state) {
            //console.log(this.treeDisp)
            this.treeDisp = !state;
            store.commit('setLeftExpand', this.treeDisp)
        },
        mCancel(next) {
            this.modalSaveNotice = false;
        },
        mSave(next) {
            this.modalSaveNotice = false;
        },
        setContentStatefalse() {
            if (store.state.user.workbook.isContentChanged) {
                // console.log("set workbook false")
                store.commit('setWorkBook', false)
            }
        },

    },
    mounted: function() {
        this.$nextTick(function() {
            // 代码保证 this.$el 在 document 中
            eventBus.$on('auto-expand', () => {
                this.$refs.cloudSider.toggleCollapse()
            })
        })


        this.pageType = this.$route.query.q_type
        this.reload()
        //this.switch()
        //console.log("mounted:"+this.pageType)
    },

    created: function() {
        //console.log("go into workbook created")
        //若存在session无需弹出窗口
        if (sessionStorage.st !== undefined) {
            return
        }
        if (store.state.user.userId === "") {
            console.log("使用云端,请先登录...")
            store.commit("setLoginForm", true)
            return
        } else {
            //console.log("3333333333333333333333333")
        }
        //store.handleSetUserLogout()
        // if (store.state.user.userId === undefined) {
        //   this.$emit('cloud-user-login')
        // }
        // this.$emit('user-login')
        //console.log('created.....')
    },
    computed: {
        ...mapGetters(['sliderLength', 'getUserId', 'getLoginForm'])
    },
    watch: {
        '$route'(to, from) {
            //console.log("watch switch...")
            //刷新参数放到这里里面去触发就可以刷新相同界面了
            //this.getStatus(this.$route.path)
            //console.log(this.$route.query.q_type)
            this.pageType = this.$route.query.q_type
            //console.log(this.pageType)
            this.switch()
        },
        getUserId: function() {
            console.log("CloudMain检查用户是否登录...")
            if (this.getUserId === undefined || this.getUserId === "") {
                this.$router.push({ path: '/main/searchengine/search' })
                eventBus.$emit("user-logoff")
                //store.commit("setLoginForm", false)
            } else {
                if (this.getUserId !== "") {
                    this.reload()
                }
            }

        }

    },
    beforeRouteLeave(to, from, next) {
        //console.log(from)
        if (from.path === '/main/cloud/mycloud') {
            // console.log(store.state.user.workbook.isContentChanged)
            if (store.state.user.workbook.isContentChanged) {
                //console.log(this.$Modal)
                this.$Modal.confirm({
                    title: '您的工作簿有内容未保存',
                    content: '<p>确定要离开并放弃保存么？</p>',
                    cancelText: "返回保存",
                    onOk: () => {
                        // this.$Message.info('Clicked ok');
                        this.setContentStatefalse()
                        next()
                    },
                    onCancel: () => {
                        //this.$Message.info('Clicked cancel');
                        next(false)
                    }
                });
                //next(false)
            } else {
                next()
            }
        } else {
            next()

        }
    },


}
</script>
<style lang="scss" scoped>
@zindex-modal: 2000;
// $main-height:81.8vh;
$main-height:88.7vh;
.siderclass {
    // height: 81.2vh;
    height: $main-height;
    left: 0;
    overflow: auto;
    background: #fff;
    z-index: 1;
    // {position: 'fixed', height: '100vh', left: 0, overflow: 'auto'}
}
.layoutstyle{
    Height: $main-height;
}

.cardstyle:hover{
    // background: yellow;
    border-radius:0px;
    box-shadow: none;
    border:none;
}
.contentclass {
    height: $main-height;
    // height: 81.2vh;
    // height: 78.8vh;
    background:#fff;
}

.ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected {
    color: white;
    background: #2d8cf0;
    z-index: 2;
}

.ivu-menu {
    position: static;
}


.maskLayer /deep/ .ivu-spin-fix {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 8;
    width: 100%;
    height: 100%;
    background-color: hsla(0, 0%, 100%, .5);
    cursor: not-allowed;
}
</style>